export interface LoaderProps {
  /** Optional message */
  message?: string | null;
  /** Additional class */
  className?: string;
}

/** An animated loader */
export const Loader = ({ message, className }: LoaderProps) => {
  const classNames = ['loader', className];
  return (
    <div className={classNames.join(' ')}>
      <span className="loader__animation" />
      {message}
    </div>
  );
};
